import { Spinner } from "@/ds/shadcn/components/ui/spinner";
import { cn } from "@/ds/utils";
import type { FC } from "react";

export interface LoadingStateProps {
	className?: string;
}

export const LoadingState: FC<LoadingStateProps> = props => {
	const {
		className
	} = props;

	return (
		<div className={cn("flex justify-center p-3", className)}>
			<Spinner />
		</div>
	);
};
